import {
  PROMOTIONAL_CODE_DISCOUNT_TYPE_FIXED,
  PROMOTIONAL_CODE_DISCOUNT_TYPE_PERCENTAGE,
  PROMOTIONAL_CODE_TYPE_STRIPE_DISCOUNT,
} from "../actions/owner";

/**
 * Applies agency stripeDiscount metadata to a plan checkout total.
 * @param {number} basePrice
 * @param {{ discount?: number, discountType?: string } | null} promoMetadata
 * @returns {number}
 */
export const applyPromotionalDiscountToPrice = (basePrice, promoMetadata) => {
  const price = Number(basePrice);
  if (!Number.isFinite(price) || price <= 0) {
    return basePrice;
  }

  const discount = Number(promoMetadata?.discount);
  const discountType = promoMetadata?.discountType;

  if (!Number.isFinite(discount) || discount <= 0 || !discountType) {
    return price;
  }

  if (discountType === PROMOTIONAL_CODE_DISCOUNT_TYPE_PERCENTAGE) {
    const pct = Math.min(100, discount);
    return Math.max(0, Math.round(price * (1 - pct / 100)));
  }

  if (discountType === PROMOTIONAL_CODE_DISCOUNT_TYPE_FIXED) {
    return Math.max(0, Math.round(price - discount));
  }

  return price;
};

/**
 * @param {string} paymentLinkUrl
 * @param {string} stripeCode
 * @returns {string}
 */
export const appendPrefilledPromoCodeToCheckoutUrl = (
  paymentLinkUrl,
  stripeCode
) => {
  const code = String(stripeCode ?? "").trim();
  if (!paymentLinkUrl || !code) {
    return paymentLinkUrl;
  }

  try {
    const url = new URL(paymentLinkUrl);
    url.searchParams.set("prefilled_promo_code", code);
    return url.toString();
  } catch {
    const separator = paymentLinkUrl.includes("?") ? "&" : "?";
    return `${paymentLinkUrl}${separator}prefilled_promo_code=${encodeURIComponent(code)}`;
  }
};

/**
 * @param {object} codeData
 * @returns {string}
 */
export const getStripeCodeFromPromoData = (codeData) =>
  String(codeData?.metadata?.stripeCode ?? codeData?.stripeCode ?? "").trim();

/**
 * @param {object} codeData
 * @returns {boolean}
 */
export const isActiveStripeDiscountPromo = (codeData) => {
  if (!codeData || codeData.type !== PROMOTIONAL_CODE_TYPE_STRIPE_DISCOUNT) {
    return false;
  }
  if (codeData.isActive === false) {
    return false;
  }
  const stripeCode = getStripeCodeFromPromoData(codeData);
  const discount = Number(codeData.metadata?.discount);
  const discountType = codeData.metadata?.discountType;
  return (
    Boolean(stripeCode) &&
    Number.isFinite(discount) &&
    discount > 0 &&
    (discountType === PROMOTIONAL_CODE_DISCOUNT_TYPE_FIXED ||
      discountType === PROMOTIONAL_CODE_DISCOUNT_TYPE_PERCENTAGE)
  );
};
